import BackButton from '../../components/buttons/backButton';
import styles from './commonView.module.css';
import { ReactNode, useState } from 'react';
import { HeaderSlotContext } from '../../context/headerSlot';
import { CommandBar, PoemCommandGroup } from '../../components';

export interface CommonViewProps {
  title?: string;
  children: ReactNode;
  actions?: ReactNode;
  withBackButton?: boolean;
  commands?: PoemCommandGroup[];
}

export function CommonView({
  title,
  children,
  actions,
  withBackButton,
  commands,
}: CommonViewProps) {
  const [headerSlot, setHeaderSlot] = useState<HTMLDivElement | null>(null);

  return (
    <>
      {commands && <CommandBar groups={commands} />}
      <div className={styles.content}>
        <div className={styles.headerBlock}>
          {withBackButton && <BackButton />}
          {title && <h1>{title}</h1>}
          <div className={styles.toolbar}>
            <div ref={setHeaderSlot} className={styles.headerSlot} />
            {actions && <div className={styles.actions}>{actions}</div>}
          </div>
        </div>
        <div className={styles.mainContent} data-main-scroll>
          <HeaderSlotContext.Provider value={headerSlot}>
            {children}
          </HeaderSlotContext.Provider>
        </div>
      </div>
    </>
  );
}

export default CommonView;
